import axios from './axios'
import { ListDTO } from './dto/list.dto'
import { JubileeOrderDTO } from './dto/jubileeOrder.dto'

class JubileeServiceClass {
  ordersList (params: { [key: string]: string | number }) {
    return async (queryParams: { [key: string]: string | number }) => {
      const res = await axios.get<ListDTO<JubileeOrderDTO>>('/api/jubilee/orders', {
        params: { ...params, ...queryParams }
      })
      return res.data
    }
  }
  /*
  async ordersList (queryParams: { [key: string]: string | number }) {
    const res = await axios.get<ListDTO<JubileeOrderDTO>>('/api/jubilee/orders', {
      params: queryParams
    })
    return res.data
  }
  */
  async createOrder (order: JubileeOrderDTO) {
    const res = await axios.post<JubileeOrderDTO>('/api/jubilee/orders', order)
    return res.data
  }

  async getConfig () {
    const res = await axios.get('/api/jubilee/orders/config')
    return res.data.data
  }

  async getFilters () {
    const res = await axios.get('/api/jubilee/orders/filters')
    return res.data
  }
}

const JubileeService = new JubileeServiceClass()

export {
  JubileeService
}
